import { Booking, CommodityPids, initialState, PidAcknowledgement, PidClass } from "../features/bookingSlice";
import { isPidSupplied, isValidPid } from "./ValidationUtilities";

export const EMPTY_PIDS: CommodityPids = { merchant: '', manufacturer: '', standardised: '' };

type PidCommodity = { productIdentifiers?: CommodityPids };

// Bookings persisted before the PID release lack these fields.
export const getPids = (commodity: PidCommodity): CommodityPids => commodity?.productIdentifiers ?? EMPTY_PIDS;
export const getPidAcknowledgement = (booking: Booking): PidAcknowledgement => booking.pidAcknowledgement ?? initialState.pidAcknowledgement;

export function isCommodityPidComplete(commodity: PidCommodity) {
  const { merchant, manufacturer } = getPids(commodity);
  return isPidSupplied(merchant) && isValidPid(merchant)
    && isPidSupplied(manufacturer) && isValidPid(manufacturer);
}

export function getIncompleteIndexes(commodities: PidCommodity[]): number[] {
  return (commodities ?? []).reduce((indexes: number[], commodity, index) => {
    if (!isCommodityPidComplete(commodity)) indexes.push(index);
    return indexes;
  }, []);
}

export function hasInvalidPid(commodities: PidCommodity[]) {
  return (commodities ?? []).some(commodity => {
    const { merchant, manufacturer, standardised } = getPids(commodity);
    return !isValidPid(merchant) || !isValidPid(manufacturer) || !isValidPid(standardised);
  });
}

export function isAcknowledgementRequired(pidClass: PidClass, commodities: PidCommodity[], hardBlock: boolean) {
  return pidClass === 'B2C' && !hardBlock && getIncompleteIndexes(commodities).length > 0;
}

export function isHardBlocked(pidClass: PidClass, commodities: PidCommodity[], hardBlock: boolean) {
  return pidClass === 'B2C' && hardBlock && getIncompleteIndexes(commodities).length > 0;
}

// Consent covers only the gaps that existed when it was given.
export function shouldClearAcknowledgement(acknowledgement: PidAcknowledgement, incompleteNow: number[], pidClass: PidClass) {
  if (!acknowledgement?.acknowledged) return false;
  if (pidClass !== 'B2C' || incompleteNow.length === 0) return true;
  const consented = acknowledgement.incompleteAtAck ?? [];
  return incompleteNow.some(index => !consented.includes(index));
}

export function rebaseIncompleteAtAck(incompleteAtAck: number[], deletedIndex: number) {
  return (incompleteAtAck ?? [])
    .filter(index => index !== deletedIndex)
    .map(index => index > deletedIndex ? index - 1 : index);
}
